import React from 'react'
import { reportViewSurveyBanner, reportStartSurveyClick } from '../../../common/analytics/surveyBannerAnalytics'
import { setLocalStorageItem, getLocalStorageItem } from '../../../common/utils/localStorageHelpers'

class PhotoduneSearchSurveyBanner extends React.Component {
  constructor (props) {
    super(props)
    this.state = { dismissed: this.isDismissed() }
  }

  dismiss () {
    setLocalStorageItem('pd-search-survey-banner-visibility', 'hidden')
    this.setState({ dismissed: true })
  }

  isDismissed () {
    return getLocalStorageItem('pd-search-survey-banner-visibility', 'visible') === 'hidden'
  }

  onDismiss = (event) => {
    event.preventDefault()
    this.dismiss()
  }

  onStartSurvey = (event) => {
    reportStartSurveyClick('PD Search Survey')
    this.dismiss()
  }

  componentDidMount () {
    if (!this.state.dismissed) reportViewSurveyBanner('PD Search Survey')
  }

  render () {
    if (this.state.dismissed) {
      return null
    }

    return (
      <div className='fds-c-alert-box fds-u-mt2 -type-success'>
        <div className='fds-c-alert-box__icon'>
          <i className='e-icon -icon-ok' />
        </div>
        <div className='fds-c-alert-box__message'>
          <p className='fds-c-text-body -size-s fds-u-m0'>
            How&apos;s searching for photos on PhotoDune? Rewarding? Frustrating? We&apos;d love to know.&nbsp;
          </p>
        </div>
        <PhotoduneSearchSurveyBanner.SurveyButton onClick={this.onStartSurvey} />
        <PhotoduneSearchSurveyBanner.DismissButton onClick={this.onDismiss} />
      </div>
    )
  }
}

PhotoduneSearchSurveyBanner.SurveyButton = ({onClick}) => {
  return (
    <a onClick={onClick} href='https://envato.formstack.com/forms/photodune_survey' target='_blank' className='fds-c-button--3d  -color-primary'>
      Share your experience
    </a>
  )
}

PhotoduneSearchSurveyBanner.DismissButton = ({onClick}) => {
  return (
    <div className='fds-c-alert-box__dismiss'>
      <a onClick={onClick} className='fds-c-alert-box__dismiss-icon'>
        <i className='e-icon -icon-cancel' />
      </a>
    </div>
  )
}

export default PhotoduneSearchSurveyBanner



// WEBPACK FOOTER //
// ./client/components/banners/photoduneSearchSurveyBanner.js